"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashCode = void 0;
// Javascript implementation of Java’s String.hashCode() method
const hashCode = (value) => {
    let hash = 0;
    if (value.length == 0) {
        return hash;
    }
    for (let i = 0; i < value.length; i++) {
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
exports.hashCode = hashCode;
//# sourceMappingURL=hashCode.js.map